export const getColorPresetClasses = (color: string | undefined | null) => {
  let bgClass = "bg-lighter";
  let hoverBgClass = "hover:bg-lighter";
  let textClass = "!bg-zinc-800";

  switch (color) {
    case "slate":
      bgClass = "bg-slate-50";
      hoverBgClass = "hover:bg-slate-100";
      textClass = "!text-slate-800";
      break;
    case "red":
      bgClass = "bg-red-50";
      hoverBgClass = "hover:bg-red-100";
      textClass = "!text-red-800";
      break;
    case "orange":
      bgClass = "bg-orange-50";
      hoverBgClass = "hover:bg-orange-100";
      textClass = "!text-orange-800";
      break;
    case "amber":
      bgClass = "bg-amber-50";
      hoverBgClass = "hover:bg-amber-100";
      textClass = "!text-amber-800";
      break;
    case "green":
      bgClass = "bg-green-50";
      hoverBgClass = "hover:bg-green-100";
      textClass = "!text-green-800";
      break;
    case "violet":
      bgClass = "bg-violet-50";
      hoverBgClass = "hover:bg-violet-100";
      textClass = "!text-violet-800";
      break;
    case "blue":
      bgClass = "bg-blue-50";
      hoverBgClass = "hover:bg-blue-100";
      textClass = "!text-blue-800";
      break;
    case "pink":
      bgClass = "bg-pink-50";
      hoverBgClass = "hover:bg-pink-100";
      textClass = "!text-pink-800";
      break;
    default:
      bgClass = "bg-lighter";
      hoverBgClass = "hover:bg-lighter";
      textClass = "!text-zinc-800";
      break;
  }

  let plainClass = `transition-colors ${bgClass} ${textClass} ${hoverBgClass}`;

  return { bgClass, textClass, hoverBgClass, plainClass };
};

/**
 * Get color preset classes for deep background
 * @param color
 * @returns - {bgClass, plainClass}
 * @example
 * const { bgClass, plainClass } = getColorPresetDeepBGClass("red"); //{ bgClass: "bg-red-500", plainClass: "transition-colors bg-red-500" }
 */
export const getColorPresetDeepBGClass = (color: string | undefined | null) => {
  let bgClass = "bg-zinc-800";

  switch (color) {
    case "slate":
      bgClass = "bg-slate-800";
      break;
    case "red":
      bgClass = "bg-red-500";
      break;
    case "orange":
      bgClass = "bg-orange-500";
      break;
    case "amber":
      bgClass = "bg-amber-500";
      break;
    case "green":
      bgClass = "bg-green-500";
      break;
    case "violet":
      bgClass = "bg-violet-500";
      break;
    case "blue":
      bgClass = "bg-blue-500";
      break;
    case "pink":
      bgClass = "bg-pink-500";
      break;
    default:
      bgClass = "bg-zinc-800";
      break;
  }

  let plainClass = `transition-colors ${bgClass}`;

  return { bgClass, plainClass };
};

export const getColorPresetStageClasses = (
  color: string | undefined | null,
) => {
  let bgClass = "bg-base-12";
  let darkBgClass = "bg-slate-800";
  let lightBgClass = "bg-slate-lighter";
  let hoverBgClass = "hover:bg-slate-lighter";
  let textClass = "!bg-zinc-800";
  let borderClass = "border-slate-base";

  switch (color) {
    case "slate":
      bgClass = "bg-base-12";
      lightBgClass = "bg-slate-lighter";
      hoverBgClass = "hover:bg-slate-lighter";
      textClass = "!text-slate-base";
      borderClass = "border-slate-base";
      darkBgClass = "bg-slate-800";
      break;
    case "red":
      bgClass = "bg-error-light";
      lightBgClass = "bg-error-lighter";
      hoverBgClass = "hover:bg-error-light";
      textClass = "!text-error-dark";
      borderClass = "border-error-base";
      darkBgClass = "bg-error-dark";
      break;
    case "orange":
      bgClass = "bg-orange-100";
      lightBgClass = "bg-orange-50";
      hoverBgClass = "hover:bg-orange-100";
      textClass = "!text-orange-800";
      borderClass = "border-orange-base";
      darkBgClass = "bg-orange-800";
      break;
    case "amber":
      bgClass = "bg-yellow-light";
      lightBgClass = "bg-yellow-lighter";
      hoverBgClass = "hover:bg-yellow-light";
      textClass = "!text-yellow-dark";
      borderClass = "border-yellow-base";
      darkBgClass = "bg-yellow-dark";
      break;
    case "green":
      bgClass = "bg-success-light";
      lightBgClass = "bg-success-lighter";
      hoverBgClass = "hover:bg-success-light";
      textClass = "!text-success-dark";
      borderClass = "border-success-base";
      darkBgClass = "bg-success-dark";
      break;
    case "violet":
      bgClass = "bg-purple-light";
      lightBgClass = "bg-purple-lighter";
      hoverBgClass = "hover:bg-purple-light";
      textClass = "!text-purple-dark";
      borderClass = "border-purple-base";
      darkBgClass = "bg-purple-dark";
      break;
    case "blue":
      bgClass = "bg-information-lighter";
      lightBgClass = "bg-information-lightest";
      hoverBgClass = "hover:bg-information-lighter";
      textClass = "!text-information-dark";
      borderClass = "border-information-base";
      darkBgClass = "bg-information-dark";
      break;
    case "pink":
      bgClass = "bg-pink-light";
      lightBgClass = "bg-pink-lighter";
      hoverBgClass = "hover:bg-pink-light";
      textClass = "!text-pink-dark";
      borderClass = "border-pink-base";
      darkBgClass = "bg-pink-dark";
      break;
    default:
      bgClass = "bg-base-12";
      lightBgClass = "bg-slate-lighter";
      hoverBgClass = "hover:bg-slate-lighter";
      textClass = "!text-zinc-800";
      borderClass = "border-slate-base";
      darkBgClass = "bg-slate-dark";
      break;
  }

  let plainClass = `transition-colors ${bgClass} ${textClass}`;
  let lightPlainClass = `transition-colors ${lightBgClass} ${textClass}`;

  return {
    bgClass,
    lightBgClass,
    textClass,
    hoverBgClass,
    plainClass,
    lightPlainClass,
    borderClass,
    darkBgClass,
  };
};
